import { stringify } from 'yaml';

export interface NoteFields {
  uuid: string; // v4, matches nocturne-writer's frontmatterSchema
  title: string;
  dateCreated: string; // ISO 8601
  dateUpdated: string; // ISO 8601
  tags: string[];
  type: 'handwritten';
  book: string;
}

export function buildNoteFile(fields: NoteFields, body: string): string {
  // Nocturne Writer quotes string values in frontmatter (e.g. uuid, title,
  // type). Match that so the files look identical to writer-generated ones.
  const yaml = stringify(fields, {
    defaultStringType: 'QUOTE_DOUBLE',
    defaultKeyType: 'PLAIN',
    lineWidth: 0,
  }).trimEnd();
  const trimmedBody = body.trimEnd();
  return `---\n${yaml}\n---\n\n${trimmedBody}\n`;
}

const MAX_SLUG_LEN = 40;

export function generateFilename(title: string, dateCreated: string): string {
  const date = dateCreated.slice(0, 10);
  const slug =
    title
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, MAX_SLUG_LEN) || 'untitled';
  return `${date}-${slug}.md`;
}
